import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { SpotOnDriverComponent } from 'src/app/spot-on-driver/spot-on-driver.component';
declare var google: any;

enum status_string {
  online = 'Online',
  offline = 'Offline',
}

@Component({
  selector: 'app-create-trip-modal',
  templateUrl: './create-trip-modal.component.html',
  styleUrls: ['./create-trip-modal.component.scss']
})
export class CreateTripModalComponent implements OnInit {

  map;
  deliveries;
  mapMarkers: any = [];
  truckIcon = {
    url: 'assets/truck-icon.svg',
    scaledSize: new google.maps.Size(30, 30)
  };
  picon = {
    url: 'assets/Pickup.svg', // url
    scaledSize: new google.maps.Size(30, 30)
  };
  columnHeaders: string[] = ['select', 'vehicle', 'driverName', 'distance'];
  showLoader=false;
  selected = 'PRIMARY';
  orderData=[];
  dataSource = new MatTableDataSource<Element>();
  columnsToDisplay = ['shipment', 'drop_location', 'booking_date', 'packages', 'type'];


  assignArr=[];
  totalAssigned = 0;
  searchMobileNo = '';
  searchVehicleNo = '';
  assignFilter: any = {};
  selection = new SelectionModel<any>(true, []);
  selectAll = false;
  vehicleByCapacity = false;
  mobile_number;
  vehicle_number;


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  constructor(private dialog: MatDialogRef<CreateTripModalComponent>,
    private http: HttpService,
    private snackBar: SnackbarService,
    private translation: TranslateService,
    private openDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public parentData: any,) { }

  ngOnInit() {
    
   this.orderData=this.parentData;
   this.dataSource = new MatTableDataSource(this.orderData);
   // this.initMap();

   this.vehicleByCapacity = false;
   this.getVehicleDetails();
  }

  closeDialog(){
    this.dialog.close();
  }
  openSpotDriver() {
    const data: any = {
     // vehicle: this.vehicle
    };
    const dialogRef = this.openDialog.open(SpotOnDriverComponent);
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if (data && data.statusCode === 200) {
          this.getVehicleDetails();
        }
      }
    );
  }
  createTrip(){
    
    
        let data=this.orderData.map(x=>x._id);
    
        let selectedTrip=this.assignArr.filter(x=>x.select==true);
    if(selectedTrip.length>0){
    
        const playload={
          express_orders: data,      
          vehicle: selectedTrip[0].driver_id,
          driver: selectedTrip[0].vehicle_type._id,
          trip_type: this.selected
        }
    
        this.http.post("express_order/create_trip", playload).subscribe(
          (data: any) => {        
            if (data.statusCode == 200) {
              this.showLoader = false;
              this.snackBar.openSnackBar(this.translation.instant('MESSAGE.CREATETRIP.SUCCESS.TRIPCREATED'), '');
              this.dialog.close();
            }
          },
          (err: any) => {        
            this.showLoader = false;
            this.snackBar.openSnackBar(err.error.message, "", "err");  
          }
        );
      }else{
        this.snackBar.openSnackBar('select atleast one check box', "", "err");  
      }
    
      }

  initMap(lat = 0, lng = 0) {
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('pathMap'), mapProp);
    google.maps.event.addListener(this.map, 'click', function (event) {
    });

  }

  getVehicleDetails(filter: any = {}) {

    filter.is_free = false;
    filter.limit = this.paginator.pageSize || 5;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    // if (this.parentData.order.vehicle && this.parentData.order.vehicle._id) {
    //   filter.vehicle_type = this.parentData.order.vehicle._id;
    // }
    if (this.searchMobileNo) {
      filter.mobile = this.searchMobileNo;
    }
    if (this.searchVehicleNo) {
      filter.vehicle_no = this.searchVehicleNo;
    }
    // if (this.isDedicatedTo) {
    //   filter.dedicated_to = this.parentData.order.shipper._id;
    // }
     filter.vehicle_by_capacity = this.vehicleByCapacity;

    //this.http.get('driver/get_all_attached?order=' + this.parentData[0]._id, filter).subscribe(
    this.http.get('driver/get_all_attached', filter).subscribe(
      (data: any) => {

        this.assignArr = [];
        this.assignArr.length = 0;
        this.totalAssigned = data.data.count;// data.data.length;
        const result = data.data.drivers;
        result.forEach(element => {
          let e: any = {
            select: false,
            driverName: element.name,
            driver_id: element._id,
            vehicle: element.vehicle_no,
            driverMobile: element.mobile,
            is_temporary: (element.driver_type && element.driver_type == 'temporary'),
            vehicle_type: element.vehicle_type ? element.vehicle_type : 'N/A',
            unitname: element.carrier_unit ? element.carrier_unit.name : '',
            distance: element.distance ? (element.distance / 1000).toFixed(0) : 'N/A',
            in_service: (element.vehicle) ? element.vehicle.maintenance ? element.vehicle.maintenance.in_service ? true : false : false : false,

            // PENDING::provision to be changed for different metrics as well
            status: element.status,
            status_string: element.status ? status_string[element.status] : 'N/A',
            current_location: element.current_location || {},
            assigned_shipment: element.assigned_shipment ? element.assigned_shipment : ''
          }
          // if (this.parentData.order.bidding_type == 'weight') {
          //   e.weight = 0;
          // }
          this.assignArr.push(e);
        });
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('ASSIGN.pagination_label');


        // (this.mapMarkers.length) ? this.removeMarkers(this.mapMarkers) : '';
      //  this.bounds = new google.maps.LatLngBounds();
        //this.placeFirstPickup(this.pickup.loc_id, 'P1', this.picon);
       // this.plotDrivers(this.assignArr);
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }

  pageNavigate(event) {
    this.assignFilter.limit = event.pageSize;
    this.assignFilter.skip = event.pageIndex * event.pageSize;
    this.selectAll = false;
    this.getVehicleDetails(this.assignFilter);
  }

  isAllSelected() {
    let count = 0;
    this.assignArr.forEach(ele => {
      if (ele.select) {
        count++;
      }
    });
    const numSelected = count;
    const numRows = this.assignArr.length;
    return numSelected === numRows;
  }
  masterToggle() {
    this.isAllSelected() ?
      this.assignArr.forEach(row => row.select = false) :
      this.assignArr.forEach(row => row.select = true);
  }

  clearMobileNumber() {
    this.mobile_number = '';
    this.applyFilter('', 'mobile');
  }
  clearVehicleNumber() {
    this.vehicle_number = '';
    this.applyFilter('', 'vehicleno')
  }
  applyFilter(filterValue: string, type: string) {
    
    if (type == 'mobile') {
      this.searchMobileNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 8) {
        this.getVehicleDetails();
      }

    } else if (type == 'vehicleno') {
      this.searchVehicleNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        this.getVehicleDetails();
      }
    }

  }

  selectCheckbox(event, element){
      
    if(event.checked=true){
      this.assignArr.forEach(x=>(element.driver_id!=x.driver_id)?x.select=false:true);      
    }else{
      this.assignArr.forEach(x=>x.select=false);
    }
  }

}
